import { render } from "./trial-balance.vue?vue&type=template&id=f5b0c7ac&scoped=true"
import script from "./trial-balance.vue?vue&type=script&lang=js"
export * from "./trial-balance.vue?vue&type=script&lang=js"

import "./trial-balance.vue?vue&type=style&index=0&id=f5b0c7ac&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5b0c7ac"]])

export default __exports__